import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { WidgetListItem } from 'src/app/interfaces/widget-list-item';
import { WidgetPanelListItems } from 'src/app/interfaces/widget-panel-list-items';
import { ToastService } from 'src/app/services/toast.service';

import { TitleContentWidgetComponent } from '../title-content-widget/title-content-widget.component';

@Component({
  selector: 'app-list-items-widget',
  templateUrl: './list-items-widget.component.html',
  styleUrls: ['./list-items-widget.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ListItemsWidgetComponent extends TitleContentWidgetComponent {
  constructor(
    private ToastService: ToastService,
    private elementRefListItem: ElementRef
  ) {
    super(elementRefListItem);
  }

  @Input() widgetPanelListItems!: WidgetPanelListItems;
  @Output() itemClick = new EventEmitter<WidgetListItem>();

  override ngOnInit(): void {
    super.ngOnInit();
    if (!this.widgetPanelListItems) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing widget panel from list items widget.',
        { returnError: true }
      );
    }
  }
}
